import { useQuery } from "hooks/useQuery";
import { getStockDetails } from "../service";

export const useStockNewsList = (symbol) => {
  return useQuery({
    queryKey: ["stockNewsList", symbol],
    queryFn: async () => {
      const response = await getStockDetails(symbol);
      return response;
    },
    enabled: Boolean(symbol),
  });
};
